import React from 'react';

export const DImage = ({ url, src, alt, style, className, width, height, fit = 'cover', loading = 'lazy' }) => {
  const inputSrc = src || url;
  if (!inputSrc) {
    return null;
  }

  let resolvedSrc = inputSrc;
  if (!/^https?:\/\//i.test(inputSrc) && !inputSrc.startsWith('data:')) {
    if (inputSrc.startsWith('/')) {
      resolvedSrc = inputSrc;
    } else {
      resolvedSrc = `/images/${inputSrc}`;
    }
  }

  const defaultStyle = {
    objectFit: fit,
    maxWidth: '50vw',
    maxHeight: '30vh',
    width: 'auto',
    height: 'auto',
    borderRadius: '12px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
    display: 'block',
  };
  const computedStyle = style ? { ...defaultStyle, ...style } : defaultStyle;

  return <img src={resolvedSrc} alt={alt || ''} className={className} style={{...computedStyle, padding:'5px', marginBottom:'10px'}} width={width} height={height} loading={loading} />;
};

export default DImage;

